import { render, staticRenderFns } from "./contact-us.vue?vue&type=template&id=1fa902b0&scoped=true"
import script from "./contact-us.vue?vue&type=script&lang=js"
export * from "./contact-us.vue?vue&type=script&lang=js"
import style0 from "./contact-us.vue?vue&type=style&index=0&id=1fa902b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa902b0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/app/components/global/breadcrumbs.vue').default,VTextField: require('/app/node_modules/vuetify/lib/components/VTextField/VTextField.js').default,VSelect: require('/app/node_modules/vuetify/lib/components/VSelect/VSelect.js').default,VTextarea: require('/app/node_modules/vuetify/lib/components/VTextarea/VTextarea.js').default,VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VSnackbar: require('/app/node_modules/vuetify/lib/components/VSnackbar/VSnackbar.js').default,VForm: require('/app/node_modules/vuetify/lib/components/VForm/VForm.js').default,SupportBlock: require('/app/components/contact-us/support-block.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VIcon,VSelect,VSnackbar,VTextField,VTextarea})
